(() => {
  const swipers = new Map();

  function waitForSwiper(cb, tries = 0) {
    if (window.Swiper && typeof window.Swiper === "function") return cb();
    if (tries > 600) return;
    requestAnimationFrame(() => waitForSwiper(cb, tries + 1));
  }

  function getCols() {
    // CSS側：PC 6 / SP 3（989px基準）
    return window.matchMedia("(max-width: 989px)").matches ? 3 : 6;
  }

  function safeUpdate(inst) {
    try {
      inst.update();
      inst.navigation?.update?.();
    } catch (e) {}
  }

  function safeAutoplay(inst) {
    try {
      inst.autoplay?.start?.();
    } catch (e) {}
  }

  function init(panel) {
    if (!panel) return;

    const swiperEl = panel.querySelector("[data-swiper]");
    if (!swiperEl) return;

    const prev = panel.querySelector(".crank-prev");
    const next = panel.querySelector(".crank-next");

    // スライド枚数を正確に取得（clone除外）
    const slideCount = swiperEl.querySelectorAll(
      ".swiper-slide:not(.swiper-slide-duplicate)"
    ).length;

    const cols = getCols();
    const canLoop = slideCount > cols;

    // 既に初期化済み
    if (swipers.has(swiperEl)) {
      const inst = swipers.get(swiperEl);

      try {
        inst.params.navigation.prevEl = prev;
        inst.params.navigation.nextEl = next;
        inst.navigation.destroy();
        inst.navigation.init();
        inst.navigation.update();
      } catch (e) {}

      // display:none → block 対策
      safeUpdate(inst);
      requestAnimationFrame(() => safeUpdate(inst));
      setTimeout(() => safeUpdate(inst), 120);

      if (canLoop) safeAutoplay(inst);
      return;
    }

    waitForSwiper(() => {
      const inst = new Swiper(swiperEl, {
        slidesPerView: "auto",
        speed: 450,
        watchOverflow: true,

        // ✅ 安全な loop 条件
        loop: canLoop,

        // ❌ これがフリーズの原因だった
        // loopAdditionalSlides: 12,

        autoplay: canLoop
          ? {
              delay: 3000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }
          : false,

        observer: true,
        observeParents: true,

        navigation: {
          prevEl: prev,
          nextEl: next,
        },
      });

      swipers.set(swiperEl, inst);

      // 初期安定化
      requestAnimationFrame(() => {
        safeUpdate(inst);
        if (canLoop) safeAutoplay(inst);
      });
      setTimeout(() => {
        safeUpdate(inst);
        if (canLoop) safeAutoplay(inst);
      }, 120);
    });
  }

  function boot(root) {
    const first =
      root.querySelector(
        ".crank-tabs__radio:checked + .crank-tabs__label + .crank-tabs__panel"
      ) || root.querySelector(".crank-tabs__panel");

    if (first) init(first);

    root.addEventListener("change", (e) => {
      const radio = e.target.closest(".crank-tabs__radio");
      if (!radio) return;

      const id = radio.id.replace("crank-tab-", "");
      const panel = root.querySelector(
        `.crank-tabs__panel[data-crank-panel="${id}"]`
      );
      if (!panel) return;

      requestAnimationFrame(() => init(panel));
    });

    // Safari / BFCache 対策
    window.addEventListener("pageshow", () => {
      const panel =
        root.querySelector(
          ".crank-tabs__radio:checked + .crank-tabs__label + .crank-tabs__panel"
        ) || root.querySelector(".crank-tabs__panel");

      if (panel) requestAnimationFrame(() => init(panel));
    });
  }

  function bootAll() {
    document.querySelectorAll('[id^="crank-"]').forEach(boot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootAll);
  } else {
    bootAll();
  }

  document.addEventListener("shopify:section:load", bootAll);
})();
